<template>
  <div class="toggle-container" @click.stop="onChange">
    <div v-if="loading" class="loader">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else-if="value" class="choice left">{{ values[0] }}</div>
    <div v-else class="choice right">{{ values[1] }}</div>
    <div v-if="value" class="date">Le {{ $utils.formatDate(date) }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    values: {
      type: Array,
      required: true,
    },

    onChange: {
      type: Function,
      required: false,
      default: () => null,
    },

    date: {
      type: String,
      required: false,
    },

    loading: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  computed: {
    ...mapGetters(['isLogged', 'user']),
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.toggle-container {
  display: flex;
  background: #e1e5ea;
  width: 100px;
  height: 30px;
  border-radius: 100px;
  position: relative;

  .loader {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  &:hover {
    cursor: pointer;

    .choice {
      transform: scale(1.1);
    }
  }

  .choice {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 65px;
    height: 30px;
    box-shadow: 0px 0px 8px #d2dae4;
    border-radius: 100px;
    background: colors.$white-color;
    color: colors.$black-color;
    font-weight: 500;
    font-size: 12px;

    &.right {
      right: 0;
      left: calc(100px - 65px);
    }

    &.left {
      background: colors.$lightblue-color;
      color: colors.$white-color;
      left: 0;
      right: calc(100px - 65px);
    }
  }

  .date {
    height: 30px;
    position: absolute;
    top: 34px;
    right: 0;
    font-size: 11px;
    color: colors.$lightgrey-color;
  }
}
</style>
